export default __webpack_public_path__ + "static/media/plans.f0c50e95.png";